import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Table, Icon } from 'antd';
import { PopDeleteConfirm } from 'components/ui/index';
import { Permission } from 'components/page/index';
import PERMISSIONS from 'config/app-permission.config';
import { toTimezone } from 'utils/dateTimeUtils';
import styles from '../index.less';
import { fetchIpList, deleteIpAddress } from '../flow/action';

const cx = classNames.bind(styles);

class IpLists extends React.Component {
  componentDidMount() {
    const { fetchIpList, ipListsData } = this.props;
    const { per_page, current_page } = ipListsData.pagination;
    fetchIpList(per_page, current_page);
  }

  handleDelete = (id) => {
    const { deleteIpAddress, ipListsData, fetchIpList } = this.props;
    const { per_page, current_page } = ipListsData.pagination;
    deleteIpAddress(id, () => {
      fetchIpList(per_page, current_page);
    });
  }

  render() {
    const { ipListsData, fetchIpList } = this.props;
    const {
      current_page,
      per_page,
      total,
    } = ipListsData.pagination;
    const pagination = {
      defaultCurrent: current_page,
      current: current_page,
      defaultPageSize: per_page,
      pageSize: per_page,
      total,
      size: 'small',
      onChange(page, pageSize) {
        fetchIpList(pageSize, page);
      },
    };

    const column = [
      {
        title: (<FormattedMessage id="global.ui.table.action" />),
        key: 'id',
        render: record => (
          <span>
            <Permission permission={PERMISSIONS.SETUP_SYSTEMS_IPWHITELIST_UPDATE}>
              <Link to={`/setup/systems/ip-setting?id=${record.id}`}>
                <Icon type="edit" className="cursor-pointer" />
              </Link>
            </Permission>
            <Permission permission={PERMISSIONS.SETUP_SYSTEMS_IPWHITELIST_DELETE}>
              <PopDeleteConfirm
                onConfirm={() => this.handleDelete(record.id)}
                placement="right"
              >
                <Icon className="pl-sm cursor-pointer" type="delete" />
              </PopDeleteConfirm>
            </Permission>
          </span>
        ),
      },
      {
        title: (<FormattedMessage id="page.IpWhiteLists.ipAddress" />),
        dataIndex: 'ip_address',
        key: 'ip_address',
      },
      {
        title: (<FormattedMessage id="page.IpWhiteLists.createdAt" />),
        dataIndex: 'created_at',
        key: 'created_at',
        render: (text, record) => {
          if (!_.isEmpty(record.created_at)) {
            return toTimezone(record.created_at, true);
          }
          return text;
        },
      },
      {
        title: (<FormattedMessage id="page.IpWhiteLists.ipStatus" />),
        dataIndex: 'ip_status',
        key: 'ip_status',
        render: (text, record) => {
          const value = record.ip_status === 1 ? (<FormattedMessage id="page.IpWhiteLists.actived" />) : (<FormattedMessage id="page.IpWhiteLists.inActived" />);
          return <span><div className={cx('ipLists-icon', `ipLists-icon-${record.ip_status === 1 ? 'active' : 'inActive'}`)} /> {value}</span>;
        },
      },
      {
        title: (<FormattedMessage id="page.IpWhiteLists.comment" />),
        dataIndex: 'comment',
        key: 'comment',
      },
    ];

    return (
      <Table
        className={`mt-lg ${cx('ipLists-table')}`}
        rowKey="id"
        size="small"
        dataSource={ipListsData.ipListsData}
        columns={column}
        pagination={pagination}
      />
    );
  }
}

IpLists.defaultProps = {};
IpLists.propTypes = {
  ipListsData: PropTypes.object.isRequired,
};

const mapStateToProps = ({ setup, global }) => ({
  language: global.language,
  ipListsData: setup.ipLists,
});

const mapDispatchToProps = {
  fetchIpList,
  deleteIpAddress,
};

export default connect(mapStateToProps, mapDispatchToProps)(IpLists);



// WEBPACK FOOTER //
// ./src/views/Setup/IpWhiteLists/component/IpListsTable.jsx